var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMsAzure(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#0078d4;}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1107.18,
    y1: -175.75,
    x2: -1126.66,
    y2: -233.31,
    gradientTransform: "translate(1774.19 -264.37) scale(1.56 -1.56)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#114a8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0669bc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -1101.07,
    y1: -202.57,
    x2: -1105.58,
    y2: -204.1,
    gradientTransform: "translate(1774.19 -264.37) scale(1.56 -1.56)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#000",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#000",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#000",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -1103.42,
    y1: -174.02,
    x2: -1082.03,
    y2: -231,
    gradientTransform: "translate(1774.19 -264.37) scale(1.56 -1.56)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3ccbf4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2892df"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m33.57,3.31h29.33l-30.48,90.21c-.65,1.87-2.45,3.17-4.4,3.17H5.18c-2.59,0-4.68-2.09-4.68-4.68,0-.5.07-1.01.22-1.51L29.1,6.48c.65-1.87,2.45-3.17,4.47-3.17h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m76.16,63.83H29.68c-1.15,0-2.16.94-2.16,2.16,0,.58.22,1.15.72,1.59l29.83,27.81c.86.79,2.02,1.3,3.17,1.3h26.3l-11.38-32.86Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m33.57,3.31c-2.02,0-3.82,1.3-4.47,3.24L.79,90.42c-.86,2.45.36,5.12,2.81,5.98.5.22,1.08.29,1.59.29h23.42c1.8-.29,3.24-1.59,3.82-3.24l5.62-16.64,20.17,18.81c.86.72,1.87,1.08,3.03,1.08h26.23l-11.53-32.86h-33.5L62.97,3.38h-29.4v-.07Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m71.04,6.48c-.65-1.87-2.45-3.17-4.4-3.17h-32.71c2.02,0,3.75,1.3,4.4,3.17l28.32,84.01c.79,2.45-.5,5.12-2.95,5.91-.5.14-1.01.22-1.51.22h32.64c2.59,0,4.68-2.09,4.68-4.68,0-.5-.07-1.01-.22-1.51L71.04,6.48Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsAzure);
export default __webpack_public_path__ + "static/media/ms-azure.c7fe05094dbdcc1376c2888a33f09cc1.svg";
export { ForwardRef as ReactComponent };